import React from 'react';
import ImagesComponent from '../Images';
import {  Box } from '@mui/material';
import TextComponent from '../Texts';

export default function ContentComponent() {
  return (
    <>
            <Box sx={{display: 'flex', 
                    flexDirection: {xs: 'column', sm: 'column', md: 'row', xl: 'row', lg: 'row'}, 
                    flex: 1,
                    maxWidth: '100%',
                    margin: 'auto',
                    width:{xs: '120vw', sm: '100vw', md: '150vw'},
                    justifyContent: 'space-around'
                    }}>
                    
                <TextComponent />
                <ImagesComponent />
            </Box> 
    </>
  );
}
